import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/live-casino', label: '真人娱乐' },
    { to: '/category/slots', label: '电子游艺' },
    { to: '/category/sports', label: '体育赛事' },
    { to: '/category/lottery', label: '彩票游戏' },
    { to: '/about', label: '关于我们' },
  ];

  const bgClass = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textClass = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-800';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${bgClass} ${scrolled ? 'border-b border-background-200/60' : ''}`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className={`flex items-center gap-2 ${textClass}`}>
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <span className="text-white font-heading font-bold text-lg md:text-xl">壹</span>
            </div>
            <span className="font-heading font-bold text-lg md:text-xl whitespace-nowrap">壹号娱乐</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer ${
                  location.pathname === link.to
                    ? scrolled || !isHome
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled || !isHome
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                scrolled || !isHome
                  ? 'border border-primary-500 text-primary-600 hover:bg-primary-50'
                  : 'border border-white/60 text-white hover:bg-white/10'
              }`}
            >
              登录
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              注册
            </Link>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${textClass}`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-6 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/60">
              <Link
                to="/about"
                className="flex-1 text-center px-5 py-2.5 rounded-full border border-primary-500 text-primary-600 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-50"
              >
                登录
              </Link>
              <Link
                to="/about"
                className="flex-1 text-center px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-600"
              >
                注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}